import { Alert, Box, CircularProgress, Table, TableBody, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { ThousandText } from "components";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectChiffreAffaireFilter } from "reducers";
import { dateFormater } from "utils/date";
import { ReportingCell } from "../common";

type Row = { id: number; libelle: string; montant: number; cumul: number };
type Props = { label: string; load: (params: Record<string, any>) => Promise<Row[]> };

export const MonthlyCaTable = ({ label, load }: Props) => {
  const filter = useSelector(selectChiffreAffaireFilter);
  const [data, setData] = useState<Row[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    if (filter?.periode?.value !== "mensuel" || !filter.mois || !filter.annee) return;
    let active = true;
    setLoading(true); setError("");
    load({ type: filter.type?.value, periode: "mensuel", mois: dateFormater.getMonth(filter.mois), annee: dateFormater.getYear(filter.annee) })
      .then((rows) => { if (active) setData(rows || []); })
      .catch(() => { if (active) { setData([]); setError("Les données n’ont pas pu être chargées."); } })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [filter, load]);
  if (loading) return <Box sx={{ py: 8, textAlign: "center" }}><CircularProgress size={30} /></Box>;
  if (error) return <Alert severity="error" sx={{ m: 2 }}>{error}</Alert>;
  return <TableContainer><Table><TableHead><TableRow><ReportingCell>{label}</ReportingCell><ReportingCell align="right">Mois sélectionné</ReportingCell><ReportingCell align="right">Cumul annuel</ReportingCell></TableRow></TableHead><TableBody>{data.length ? data.map((item) => <TableRow hover key={item.id}><ReportingCell><Typography variant="body2" fontWeight={600}>{item.libelle}</Typography></ReportingCell><ReportingCell align="right"><ThousandText value={item.montant} /></ReportingCell><ReportingCell align="right"><ThousandText value={item.cumul} /></ReportingCell></TableRow>) : <TableRow><ReportingCell colSpan={3} align="center" sx={{ py: 7, color: "text.secondary" }}>Aucun chiffre d’affaires sur ce mois</ReportingCell></TableRow>}</TableBody></Table></TableContainer>;
};
